import appEnv from './../../app.env.json';

export const environment = {
  production: false,
  PUBLIC_CONFIG: {
    // If no configuration is passed default to local
    ...appEnv.local.PublicConfig,
  },
};
